import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	popperStyles: {
		marginTop     : "1rem",
		background    : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,
		border        : "1px solid",
		borderColor   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey,
		borderRadius  : "24px",
		width         : "350px",
		display       : "flex",
		flexDirection : "column",
		padding       : "0"
	},
	tagsWrapper: {
		display  : "flex",
		flexWrap : "wrap",
		gap      : "1rem",
		padding  : "1rem"
	},
	tagName: {
		// background   : "#fff",
		borderRadius    : "10px",
		border          : "1px solid",
		borderColor     : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey,
		color           : theme.other.colors.text.primary,
		textAlign       : "center",
		padding         : "0.5rem 2rem",
		fontSize        : "1.3rem",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryBackgroundGrey,
		cursor          : "pointer"
	},
	tagTitle: {
		fontSize: "1.3rem"
	},
	tagButtonsWrapper: {
		display        : "flex",
		width          : "100%",
		justifyContent : "flex-end",
		margin         : "1rem 0 0",
		padding        : "1rem 0",
		gap            : "1rem",
		background     : theme.other.colors.background.tertiary,
		borderRadius   : "0 0 24px 24px"
	},
	cancelTagsButton: {
		background   : "none",
		fontSize     : "1.4rem",
		color        : "#126bd5",
		border       : "1px solid #126bd5",
		padding      : "0.5rem 1rem",
		borderRadius : "10px"
	},
	saveTagsButton: {
		background   : theme.other.paletteNew.primaryLinearGradient,
		fontSize     : "1.4rem",
		border       : "1px solid #126bd5",
		padding      : "0.5rem 1.5rem",
		borderRadius : "10px",
		marginRight  : "1rem"
	}
} ) );
